import { IPartner } from "@/types/partner";
import { ISelectItem } from "@/types";

export class Partner implements IPartner {
  public id = 0;
  public name = "";
  public kana = "";
  public tel = "";
  public staff = "";
  public cutoff_at = "";
  public company_id = 0;
  public user_id = 0;
  public categories = [];
  public created_at = "";
  public updated_at = "";

  public static toSelectItem(partner: IPartner): ISelectItem {
    return {
      text: partner.name,
      value: partner.id
    };
  }
}
